"use client";

import { c as _c } from "react/compiler-runtime";
;
/* eslint-disable @next/next/no-img-element */
import { Button, Divider, Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger, Link, Navbar, NavbarBrand, NavbarContent, NavbarItem, NavbarMenu, NavbarMenuItem, NavbarMenuToggle } from "@heroui/react";
import { useIsMobile } from "@/hooks/utility/useIsMobile";
import { ArrowRightLeft, ChevronRight, Droplets, WalletIcon } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import React, { useCallback, useState } from "react";
import ConnectButton from "../components/Buttons/ConnectButton";
import { imageLogo, pageTitle, telegram, twitter } from "../constants";
import StakingLogo from "./StakingLogo";
import { usePortfolioOpen } from "@/hooks/modals/usePortfolioOpen";
import { connectBtnTheme } from "@/constants/project-specific/theme/connectbutton";
import { useConnection } from "wagmi";
export default function Header() {
  const $ = _c(81);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const {
    isConnected
  } = useConnection();
  const isMobile = useIsMobile();
  const {
    onOpen: onPortfolioOpen
  } = usePortfolioOpen();
  let T0;
  let T1;
  let T2;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== expandedMenu || $[1] !== isConnected || $[2] !== isMenuOpen || $[3] !== isMobile || $[4] !== onPortfolioOpen) {
    const menuItems = [{
      label: "Swap Tokens",
      link: "../../../swap"
    }, {
      label: "Manage Liquidity",
      link: "../../../liquidity"
    }, {
      label: "Bridge Cross-Chain",
      link: "../../../bridge"
    }, {
      label: "Staking & Farms",
      submenu: [{
        label: "All Chain Pools",
        link: "../../../farms"
      }, {
        label: "Shibarium Pools",
        link: "../../../farms/shibarium"
      }, {
        label: "Dogechain Pools",
        link: "../../../farms/dogechain"
      }]
    }, {
      label: "NFT Staking",
      link: "../../../nft-staking"
    }, {
      label: "NFT Marketplace",
      link: "../../../marketplace"
    }, {
      label: "News & Updates",
      link: "../../../news"
    }, {
      label: "Rescue Mission",
      link: "../../../rescue"
    }, {
      label: "Divider"
    }, {
      label: "Telegram",
      link: telegram
    }, {
      label: "Twitter",
      link: twitter
    }, {
      label: "Documentation",
      link: "https://docs.chewyswap.com"
    }];
    const handleMenuToggle = label => {
      setExpandedMenu(expandedMenu === label ? null : label);
    };
    T2 = Navbar;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => setIsMenuOpen(false);
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    t6 = true;
    t7 = "p-0 md:p-2";
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        wrapper: "max-w-full",
        item: ["flex", "relative", "h-full", "items-center", "data-[active=true]:after:content-['']", "data-[active=true]:after:absolute", "data-[active=true]:after:bottom-0", "data-[active=true]:after:left-0", "data-[active=true]:after:right-0", "data-[active=true]:after:h-[2px]", "data-[active=true]:after:rounded-[2px]", "data-[active=true]:after:bg-primary"]
      };
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    t9 = setIsMenuOpen;
    t10 = isMenuOpen;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <NavbarContent justify="start"><NavbarBrand className="-m-4 md:m-0"><StakingLogo />{!imageLogo && <p className="font-bold text-inherit">{pageTitle}</p>}</NavbarBrand></NavbarContent>;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t15;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <DropdownTrigger><Button as={Link} size="md" variant="light">Tokens</Button></DropdownTrigger>;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <DropdownItem key="agg" color="secondary" href="../../../swap" startContent={<ArrowRightLeft width="15" height="15" className="p-0 mx-1" />}>Swap Aggregator</DropdownItem>;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    let t17;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <DropdownSection title="Swaps + LP on ANY DEX">{t16}<DropdownItem key="agg" color="secondary" href="../../../liquidity" startContent={<Droplets width="15" height="15" className="p-0 mx-1" />}>Manage Liquidity</DropdownItem><DropdownItem key="divider" color="secondary" showDivider={true} /></DropdownSection>;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    let t18;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <DropdownItem key="shibswap" color="secondary" href={`../../../link?to=https://chewyswap.dog/swap${encodeURIComponent("?chain=shibarium")}`} startContent={<img width={15} height={15} src="https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shib.webp" alt="Shibarium" className="menuItemImg" />}>Shibarium</DropdownItem>;
      $[29] = t18;
    } else {
      t18 = $[29];
    }
    let t19;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <NavbarItem><Dropdown>{t15}<DropdownMenu variant="flat" color="secondary" aria-label="Swap Chains Menu">{t17}<DropdownSection title="OG ChewySwap Site:">{t18}<DropdownItem key="dcswap" color="secondary" href={`../../../link?to=https://chewyswap.dog/swap${encodeURIComponent("?chain=dogechain")}`} startContent={<img width={15} height={15} src="https://chewyswap.dog/images/chains/2000.png" alt="Dogechain" className="menuItemImg" />}>Dogechain</DropdownItem></DropdownSection></DropdownMenu></Dropdown></NavbarItem>;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    let t20;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <NavbarItem><Button as={Link} href="../../../bridge" size="md" variant="light">Bridge</Button></NavbarItem>;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    let t21;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <DropdownTrigger><Button as={Link} size="md" variant="light">Staking</Button></DropdownTrigger>;
      $[32] = t21;
    } else {
      t21 = $[32];
    }
    let t22;
    let t23;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <DropdownItem key="all" color="secondary" href="../../../farms">All Farms</DropdownItem>;
      t23 = <DropdownItem key="divider" color="secondary" showDivider={true} />;
      $[33] = t22;
      $[34] = t23;
    } else {
      t22 = $[33];
      t23 = $[34];
    }
    let t24;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <DropdownItem key="shibfarms" href="../../../farms/shibarium" startContent={<img width={15} height={15} src="https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shib.webp" alt="Shibarium" className="menuItemImg" />}>Shibarium Farms</DropdownItem>;
      $[35] = t24;
    } else {
      t24 = $[35];
    }
    let t25;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = <DropdownSection title="Chains">{t24}<DropdownItem key="dogefarms" href="../../../farms/dogechain" startContent={<img width={15} height={15} src="https://chewyswap.dog/images/chains/2000.png" alt="Dogechain" className="menuItemImg" />}>Dogechain Farms</DropdownItem></DropdownSection>;
      $[36] = t25;
    } else {
      t25 = $[36];
    }
    let t26;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <NavbarItem><Dropdown>{t21}<DropdownMenu variant="flat" color="secondary" aria-label="Farms and Pools Menu">{t22}{t23}{t25}<DropdownSection title="NFT Staking"><DropdownItem key="shibpool" href="../../../nft-staking" startContent={<img width={15} height={15} src="https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shib.webp" alt="Shibarium" className="menuItemImg" />}>Stake Shiboshis</DropdownItem></DropdownSection></DropdownMenu></Dropdown></NavbarItem>;
      $[37] = t26;
    } else {
      t26 = $[37];
    }
    let t27;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <NavbarItem><Button as={Link} href="../../../news" size="md" variant="light">News</Button></NavbarItem>;
      $[38] = t27;
    } else {
      t27 = $[38];
    }
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <NavbarContent className="justify-center gap-0 hidden sm:flex" justify="center">{t19}{t20}{t26}{t27}<NavbarItem><Button as={Link} href="../../../marketplace" size="md" variant="light">Marketplace</Button></NavbarItem></NavbarContent>;
      $[39] = t12;
    } else {
      t12 = $[39];
    }
    let t28;
    if ($[40] !== isConnected || $[41] !== isMobile || $[42] !== onPortfolioOpen) {
      t28 = isConnected && !isMobile && <NavbarItem><Button size={connectBtnTheme.states?.connected.size ?? "md"} variant={connectBtnTheme.states?.connected.variant ?? "light"} color={connectBtnTheme.states?.connected.color ?? "secondary"} className={connectBtnTheme.states?.connected.className ?? ""} radius={connectBtnTheme.states?.connected.radius ?? "lg"} onPress={() => onPortfolioOpen("portfolio")} isIconOnly={true}><WalletIcon size={24} /></Button></NavbarItem>;
      $[40] = isConnected;
      $[41] = isMobile;
      $[42] = onPortfolioOpen;
      $[43] = t28;
    } else {
      t28 = $[43];
    }
    let t29;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = <NavbarItem><ConnectButton allowedChainIds={[109, 2000]} /></NavbarItem>;
      $[44] = t29;
    } else {
      t29 = $[44];
    }
    if ($[45] !== t28) {
      t13 = <NavbarContent justify="end" className="gap-1">{t28}{t29}</NavbarContent>;
      $[45] = t28;
      $[46] = t13;
    } else {
      t13 = $[46];
    }
    const t30 = isMenuOpen ? "Close menu" : "Open menu";
    if ($[47] !== t30) {
      t14 = <NavbarMenuToggle aria-label={t30} className="" />;
      $[47] = t30;
      $[48] = t14;
    } else {
      t14 = $[48];
    }
    T1 = NavbarMenu;
    t1 = "mt-0 md:pt-6 w-full md:w-1/3 place-self-auto md:place-self-end overflow-x-hidden";
    t2 = "menu";
    t3 = "Main Navigation";
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span className="text-xl text-warning mb-2">Chewy Pages:</span>;
      $[49] = t4;
    } else {
      t4 = $[49];
    }
    T0 = AnimatePresence;
    t0 = menuItems.map((item, index) => <React.Fragment key={`menu-${item.label}-${index}`}>{item.label === "Divider" ? <><Divider className="mb-2 bg-gradient-to-r from-white/0 via-white/25 to-white/0" /><span className="text-xl text-warning mb-2">Chewy Links:</span></> : <NavbarMenuItem key={`menuitem-${item.label}-${index}`} role="menuitem" aria-haspopup={item.submenu ? "true" : undefined} aria-expanded={item.submenu ? expandedMenu === item.label : undefined} aria-controls={item.submenu ? `${item.label}-submenu` : undefined}><Link aria-label={item.submenu ? `expand ${item.label} submenu` : item.label} color="foreground" className="w-full text-xl" href={item.link ?? "#"} isExternal={item.link?.includes("https://")} showAnchorIcon={item.link?.includes("https://")} size="lg" onPress={() => {
          if (item.submenu) {
            handleMenuToggle(item.label);
          } else {
            setIsMenuOpen(false);
          }
        }}><ChevronRight className={`ml-2 transition-transform ${expandedMenu === item.label ? "rotate-90" : ""}`} /><span className={item.link?.includes("https://") ? "mr-2" : ""}>{item.label}</span></Link>{expandedMenu === item.label && item.submenu && <motion.div key={`${item.label}-menu`} id={`${item.label}-submenu`} role="menu" aria-label={`${item.label} submenu`} initial={{
          scaleY: "0%"
        }} animate={{
          scaleY: "100%"
        }} exit={{
          scaleY: "0%"
        }} transition={{
          duration: 0.5
        }} className="ml-4 mt-2">{item.submenu.map((subItem, subIndex) => <Button as={Link} size="md" variant="light" key={`submenu-${subItem.label}-${subIndex}`} href={subItem.link} className="block p-2 text-gray-200 hover:bg-gray-100 rounded-md" role="menuitem" onPress={() => {
            setIsMenuOpen(false);
            handleMenuToggle(item.label);
          }} onKeyDown={e => {
            if (e.key === "Escape") {
              handleMenuToggle(item.label);
            }
          }}>- {subItem.label}</Button>)}</motion.div>}</NavbarMenuItem>}</React.Fragment>);
    $[0] = expandedMenu;
    $[1] = isConnected;
    $[2] = isMenuOpen;
    $[3] = isMobile;
    $[4] = onPortfolioOpen;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = t0;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    t0 = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t2 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  let t15;
  if ($[50] !== T0 || $[51] !== t0) {
    t15 = <T0>{t0}</T0>;
    $[50] = T0;
    $[51] = t0;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  let t16;
  if ($[53] !== T1 || $[54] !== t1 || $[55] !== t15 || $[56] !== t2 || $[57] !== t3 || $[58] !== t4) {
    t16 = <T1 className={t1} role={t2} aria-label={t3}>{t4}{t15}</T1>;
    $[53] = T1;
    $[54] = t1;
    $[55] = t15;
    $[56] = t2;
    $[57] = t3;
    $[58] = t4;
    $[59] = t16;
  } else {
    t16 = $[59];
  }
  let t17;
  if ($[60] !== T2 || $[61] !== t10 || $[62] !== t11 || $[63] !== t12 || $[64] !== t13 || $[65] !== t14 || $[66] !== t16 || $[67] !== t5 || $[68] !== t6 || $[69] !== t7 || $[70] !== t8 || $[71] !== t9) {
    t17 = <T2 onScrollPositionChange={t5} shouldHideOnScroll={t6} className={t7} classNames={t8} onMenuOpenChange={t9} isMenuOpen={t10}>{t11}{t12}{t13}{t14}{t16}</T2>;
    $[60] = T2;
    $[61] = t10;
    $[62] = t11;
    $[63] = t12;
    $[64] = t13;
    $[65] = t14;
    $[66] = t16;
    $[67] = t5;
    $[68] = t6;
    $[69] = t7;
    $[70] = t8;
    $[71] = t9;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  let t18;
  if ($[73] !== isMenuOpen) {
    t18 = isMenuOpen && <div className="fixed inset-0 bg-black/0 z-20" onClick={() => setIsMenuOpen(false)} onKeyDown={e_0 => {
      if (e_0.key === "Enter" || e_0.key === " ") {
        setIsMenuOpen(false);
      }
    }} tabIndex={0} role="button" />;
    $[73] = isMenuOpen;
    $[74] = t18;
  } else {
    t18 = $[74];
  }
  const t19 = expandedMenu ? `${expandedMenu} submenu expanded` : "Menu collapsed";
  let t20;
  if ($[75] !== t19) {
    t20 = <div className="sr-only" aria-live="polite">{t19}</div>;
    $[75] = t19;
    $[76] = t20;
  } else {
    t20 = $[76];
  }
  let t21;
  if ($[77] !== t17 || $[78] !== t18 || $[79] !== t20) {
    t21 = <>{t17}{t18}{t20}</>;
    $[77] = t17;
    $[78] = t18;
    $[79] = t20;
    $[80] = t21;
  } else {
    t21 = $[80];
  }
  return t21;
}